import React from 'react';

const AIKarakterSederhanaScratch: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Game akan terasa membosankan jika karakter musuh atau rintangan hanya bergerak bolak-balik dalam pola kaku yang mudah ditebak. Untuk membuat permainan lebih menantang, kita dapat memprogram kecerdasan buatan sederhana (<i>Simple AI Behavior</i>) agar musuh dapat merespons posisi pemain secara cerdas.
      </p>

      <p className="mb-4">
        Di platform Scratch, pembuatan perilaku AI tidak memerlukan algoritma jaringan saraf tiruan yang rumit. Dengan menerapkan logika komparasi koordinat dan penjejakan vektor dasar, musuh dapat mengejar, berpatroli, atau menghindari karakter pemain secara dinamis.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Tiga Pola Perilaku AI yang Mudah Dibuat
      </h2>
      <div className="grid md:grid-cols-3 gap-4 mb-4">
        <div className="border border-gray-200 rounded-lg p-3 bg-white">
          <h3 className="font-semibold text-defaultBlue mb-1">🎯 Penjejak (Chaser)</h3>
          <p className="text-sm text-gray-600">Musuh mengarahkan diri ke arah pemain dengan perintah <code>point towards Player</code> dan bergerak maju dengan kecepatan tertentu.</p>
        </div>
        <div className="border border-gray-200 rounded-lg p-3 bg-white">
          <h3 className="font-semibold text-defaultBlue mb-1">🛡️ Penjaga Wilayah (Patrol)</h3>
          <p className="text-sm text-gray-600">Musuh berpatroli di antara dua titik koordinat X dan baru mengejar jika jarak pemain berada dalam radius deteksi (<i>distance to player &lt; 100</i>).</p>
        </div>
        <div className="border border-gray-200 rounded-lg p-3 bg-white">
          <h3 className="font-semibold text-defaultBlue mb-1">🏹 Penembak Acak (Turret)</h3>
          <p className="text-sm text-gray-600">Musuh tetap diam di tempat dan menembakkan proyektil klon (<code>create clone of bullet</code>) secara berkala ke arah pemain.</p>
        </div>
      </div>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Menghindari Gerakan Robotik yang Kaku
      </h2>
      <p className="mb-4">
        Agar gerakan musuh terlihat lebih alami, tambahkan sedikit jeda waktu acak menggunakan blok <code>pick random 0.5 to 1.5 secs</code> dan batasi kecepatan rotasi musuh. Sentuhan kecil ini membuat musuh terasa seperti memiliki jeda berpikir sebelum bereaksi.
      </p>

      <p className="mb-4">
        Bereksperimen dengan logika perilaku agen virtual di Scratch memberikan pemahaman awal yang kokoh bagi siswa mengenai bagaimana sistem otomatisasi dan AI bekerja di dunia game komersial.
      </p>
    </div>
  );
};

export default AIKarakterSederhanaScratch;
